<template>
  <div>
    <v-card flat :loading="loading" class="tab-details">
      <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.decisions }}
        </div>
        <v-row class="mx-12">
          <template>
            <v-col v-for="(decision, index) in decisions" :key="index" cols="4">
              <decision-card :decision="decision" @decision-card-click="openDecisionInfo(decision)"></decision-card>
            </v-col>
          </template>
          <v-col cols="12">
            <naj-no-data :has-data="decisions && decisions.length > 0" :loading="loading"></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <degree-color-palette></degree-color-palette>
    <pdf-decisions-modal
      :decisions="decisions"
      :selected-decision-index-prop="selectedDecisionIndex"
      :modal-visibility="showDecisionInfoModal"
      @modalClose="closeDecisionInfo"
    ></pdf-decisions-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate, getTimePart } from '@/helpers/utils';
import DecisionCard from '../../../../global/components/cards/decision-card.vue';
import DegreeColorPalette from '../../case-file/degree-color-palette/index.vue';
import PdfDecisionsModal from '../../pdf-decisions-modal';

export default {
  name: 'IncomingRequestDecisionsTab',
  components: {
    DecisionCard,
    DegreeColorPalette,
    PdfDecisionsModal,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    caseObjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      decisions: [],
      loading: false,
      selectedDecisionIndex: 0,
      showDecisionInfoModal: false,
    };
  },
  mounted() {
    if (this.id) {
      this.loadData();
    }
  },
  methods: {
    ...mapActions(['getCaseDecisions']),
    toHijriDate,
    getTimePart,
    loadData() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: 'true',
      };
      this.loading = true;
      this.getCaseDecisions(params)
        .then((res) => {
          if (res.data) {
            this.decisions = res.data.filter(d => d.id.toString() == this.id.toString());
          }
        })
        .finally(() => (this.loading = false));
    },
    openDecisionInfo(decision) {
      this.showDecisionInfoModal = true;
      this.selectedDecisionIndex = this.decisions.findIndex((a) => a.id == decision.id);
    },
    closeDecisionInfo() {
      this.showDecisionInfoModal = false;
      this.selectedDecisionIndex = 0;
    },
  },
};
</script>

<style scoped></style>
